import { Divider, Grid } from "@material-ui/core"
import {  FinalizadoraModel } from "api/cardapio/models/finalizadora/finalizadora-model"
import { usePagamentos } from "services/hooks/use-pagamentos"
import { CardFormaPagamento } from "components/cards/card-forma-pagamento/card-forma-pagamento"
import React from "react"
import { EnumPagTpMod } from "models/enums/enum-pag-tpmod"


export type SelecioanrFormaPagamentoListProps = {
    tpPagamento: "entrega" | "interno" | null
    setMostrarDinheiro: React.Dispatch<React.SetStateAction<boolean>>
    setFinalizadoraSelecionada: React.Dispatch<React.SetStateAction<FinalizadoraModel | undefined>>
}

export const SelecionarFormaPagamentoList = ({ tpPagamento, setMostrarDinheiro, setFinalizadoraSelecionada }: SelecioanrFormaPagamentoListProps) => {
    const { getFormasPagamentoIntegrados, getFormasPagamentoNaoIntegrado } = usePagamentos()
    const formasPagamento = tpPagamento === 'entrega' ? getFormasPagamentoNaoIntegrado() : getFormasPagamentoIntegrados()
    const formasPagamentoUnicas = formasPagamento.reduce((acumulado, formaPagamento) => {
        if (!acumulado.find((item) => item.tpMod === formaPagamento.tpMod && item.tpTransacao === formaPagamento.tpTransacao)) {
            acumulado.push(formaPagamento)
        }
        return acumulado
    }, [] as FinalizadoraModel[])

    const formaPagamentoDinheiro = formasPagamentoUnicas.find((item) => item.tpMod === EnumPagTpMod.DINHEIRO)
    const formasPagamentoNaoDinheiro = formasPagamentoUnicas.filter((item) => item.tpMod !== EnumPagTpMod.DINHEIRO)

    return (
        <Grid container spacing={3}>
            {formaPagamentoDinheiro && (
                <>
                    <Grid item xs={12} key={formaPagamentoDinheiro.id}>
                        <CardFormaPagamento
                            model={formaPagamentoDinheiro}
                            onClick={() => {
                                setFinalizadoraSelecionada(formaPagamentoDinheiro)
                                setMostrarDinheiro(true)
                            }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </>
            )}
            {
                formasPagamentoNaoDinheiro
                    .sort((a, b) => a.descricao.localeCompare(b.descricao))
                    .map((formaPagamento) => (
                        <Grid item xs={12} key={formaPagamento.id}>
                            <CardFormaPagamento model={formaPagamento} onClick={setFinalizadoraSelecionada} />
                        </Grid>
                    ))
            }
        </Grid>
    )
}